import React, { Component } from "react";
import { Form, Input, DatePicker } from "antd";
import PhoneInput from "react-phone-input-2";
import { PersonId } from "./person-id/person-id";
import { InputNumber } from "../../../../components/common/input-number";
import { Dropdown } from "../../../../components/common/dropdown";
import { CardType } from "../../user/card-type/card-type";
import { apiDriver } from "../../../../api/api-driver";
import { checkDriverType } from "../driver-list/driver-event";
import moment from "moment";

const dataField = [
  {
    title: "* Mã nhân viên::",
    fieldName: "employee_id",
  },
  {
    title: "* Tên tài xế::",
    fieldName: "driver_name",
  },
  {
    title: "* Mã số cá nhân::",
    title2: "Mã số cá nhân::",
    fieldName: "indentify_number",
    type: "mscn",
  },
  {
    title: " ",
    fieldName: "card_type",
    type: "card_type",
  },
  {
    title: "* Ngày sinh::",
    title2: "Ngày sinh::",
    fieldName: "birthday",
    type: "date",
  },
  {
    title: "* Địa chỉ::",
    title2: "Địa chỉ::",
    fieldName: "address",
  },
  {
    title: "* Số điện thoại::",
    title2: "Số điện thoại::",
    fieldName: "mobile",
    type: "mobile",
    validation: /^-{0,1}\d*\.{0,1}\d+$/,
  },
  {
    title: "Email::",
    fieldName: "email",
    validation: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
  },
  {
    title: "Bằng lái::",
    fieldName: "license",
  },
  {
    title: "* Nguồn nhân sự::",
    fieldName: "resources",
    type: "resources",
  },
  {
    title: "* Chi nhánh::",
    fieldName: "branch",
    type: "branch",
  },
  {
    title: "* Số bằng lái::",
    title2: "Số bằng lái::",
    fieldName: "number_license",
    type: "number",
  },
];

export class LeftForm extends Component {
  state = {
    country_code: "+84",
    mobile: "",
    iso2: "vn",
    showPassword: true,
    activeEye: false,
    supplierGroups: [],
    branches: [],
    number_license: "",
  };

  setPhone = (phone) => {
    let country_code = "+84";
    let iso2 = "vn";
    if (this.phone) {
      const { selectedCountry } = this.phone.state;
      country_code = selectedCountry.dialCode;
      iso2 = selectedCountry.iso2;
    }
    this.setState({
      country_code,
      mobile: phone.replace(country_code, "").replace("+", ""),
      iso2,
    });
  };

  onSelectBranch = (data) => {
    const { onChangeForm } = this.props;
    onChangeForm("branch", data.code);
  };

  onSelectResource = (data) => {
    const { onChangeForm } = this.props;
    onChangeForm("resources", data.code);
    this.props.setResources(data);
  };

  handleLicenseNumber = (e) => {
    const { value } = e.target;
    this.props.onChangeForm("number_license", value.replace(/\D+/g, ""));
    this.setState({
      number_license: value.replace(/\D+/g, ""),
    });
  };

  render() {
    const { editable, typeOption, customerResource } = this.props;
    const {
      iso2,
      supplierGroups,
      branches,
      country_code,
      number_license,
    } = this.state;

    return (
      <div className="left-form">
        {dataField.map((field) => {
          return (
            <Form.Item
              className={
                field.fieldName === "email" || field.fieldName === "license"
                  ? "alignText"
                  : customerResource &&
                    (field.fieldName === "indentify_number" ||
                      field.fieldName === "address" ||
                      field.fieldName === "birthday" ||
                      field.fieldName === "number_license")
                  ? "requireField"
                  : ""
              }
              wrapperCol={15}
              key={field.fieldName}
              label={
                customerResource &&
                (field.fieldName === "indentify_number" ||
                  field.fieldName === "address" ||
                  field.fieldName === "birthday" ||
                  field.fieldName === "number_license")
                  ? field.title2
                  : field.title
              }
              name={field.fieldName}
              rules={
                field.fieldName === "driver_name"
                  ? [
                      {
                        required: true,
                        message: `Vui lòng nhập Tên tài xế!`,
                      },
                    ]
                  : field.fieldName === "indentify_number" ||
                    field.fieldName === "address" ||
                    field.fieldName === "birthday" ||
                    field.fieldName === "number_license"
                  ? [checkDriverType(field.title)]
                  : // : field.fieldName === 'indentify_number' ? [{
                  //   required: true,
                  //   message: `Vui lòng nhập Mã số cá nhân!`,
                  // },
                  // {
                  //   max: 25,
                  //   message: 'Mã số cá nhân vượt quá 25 ký tự!'
                  // }] : field.fieldName === 'birthday' && !customerResource ? [{
                  //   required: true,
                  //   message: `Vui lòng chọn Ngày sinh!`,
                  // }] : field.fieldName === 'address' && !customerResource ? [{
                  //   required: true,
                  //   message: `Vui lòng nhập Địa chỉ!`,
                  // },
                  // {
                  //   max: 255,
                  //   message: 'Địa chỉ vượt quá 255 ký tự!'
                  // }]
                  field.fieldName === "mobile"
                  ? [
                      ({ getFieldValue }) => ({
                        validator(rule, v) {
                          if (!v) {
                            return Promise.reject(
                              `Vui lòng nhập Số điện thoại!`
                            );
                          }
                          if (v.length < 12) {
                            return Promise.reject(
                              `Số điện thoại không đúng định dạng!`
                            );
                          }
                          if (v.length > 15) {
                            return Promise.reject(
                              `Số điện thoại không đúng định dạng!`
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]
                  : field.fieldName === "email"
                  ? [
                      ({ getFieldValue }) => ({
                        validator(rule, value) {
                          if (field.fieldName === "email") {
                            if (value) {
                              const listCheck = value.split("@");

                              if (
                                value.includes("..") ||
                                listCheck[0].startsWith(".") ||
                                listCheck[0].endsWith(".") ||
                                (listCheck.length > 1 &&
                                  listCheck[1].startsWith(".")) ||
                                (listCheck.length > 1 &&
                                  listCheck[1].endsWith("."))
                              ) {
                                return Promise.reject(
                                  "Vui lòng kiểm tra lại Email!"
                                );
                              }
                              if (value.length > 255) {
                                return Promise.reject(
                                  "Email vượt quá 100 ký tự!"
                                );
                              }
                              if (field?.validation.test(value)) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                "Vui lòng kiểm tra lại Email!"
                              );
                            } else {
                              return Promise.resolve();
                            }
                          }
                        },
                      }),
                    ]
                  : // : field.fieldName === 'number_license' && !customerResource ? [{
                  //   required: true,
                  //   message: `Vui lòng nhập Số bằng lái!`,
                  // }]
                  field.fieldName === "branch"
                  ? [
                      {
                        required: true,
                        message: `Vui lòng chọn Chi nhánh!`,
                      },
                    ]
                  : field.fieldName === "resources" && !customerResource
                  ? [
                      {
                        required: true,
                        message: `Vui lòng chọn Nguồn nhân sự!`,
                      },
                    ]
                  : null
              }
            >
              {field.type === "mscn" ? (
                <Input disabled={!editable} placeholder="Mã số cá nhân" />
              ) : field.type === "card_type" ? (
                <CardType
                  disabled={!editable}
                  onChangeFormValues={this.onChangeFormValues}
                />
              ) : field.type === "number" ? (
                <Input
                  placeHolder="Số bằng lái"
                  value={number_license}
                  onChange={this.handleLicenseNumber}
                  disabled={!editable}
                />
              ) : field.type === "date" ? (
                <DatePicker
                  disabled={!editable}
                  // inputReadOnly
                  dropdownClassName="date-picker-dropdown-top"
                  getPopupContainer={(node) => {
                    if (node) {
                      return node.parentNode;
                    }
                    return document.body;
                  }}
                  format="DD/MM/YYYY"
                  className="dropdown-full"
                  disabledDate={(currentDate) => {
                    const currentTimes = currentDate.valueOf();
                    const nowTimes = moment().endOf("day").valueOf();
                    return currentTimes >= nowTimes;
                  }}
                />
              ) : field.type === "mobile" ? (
                <PhoneInput
                  disabled={!editable}
                  ref={(ref) => (this.phone = ref)}
                  autoFormat={false}
                  countryCodeEditable={false}
                  onChange={this.setPhone}
                  country={iso2}
                />
              ) : field.type === "resources" ? (
                <Dropdown
                  select={this.onSelectResource}
                  disabled={!editable || typeOption !== "create_new"}
                  className="dropdown-full"
                  menu={supplierGroups}
                  title="Nguồn nhân sự"
                />
              ) : field.type === "branch" ? (
                <Dropdown
                  select={this.onSelectBranch}
                  disabled={!editable}
                  className="dropdown-full"
                  menu={branches}
                  title="Chi nhánh"
                />
              ) : (
                <Input
                  placeholder={field.title.replace(/[:*]/gi, "").trim()}
                  disabled={!editable || field.fieldName === "employee_id"}
                />
              )}
            </Form.Item>
          );
        })}
      </div>
    );
  }
}
